interface Props {
  data: number[];
  width?: number;
  height?: number;
  color?: string;
  showDot?: boolean;
  showGradient?: boolean;
}

export function Sparkline({
  data, width = 60, height = 20,
  color = '#60a5fa', showDot = true, showGradient = true,
}: Props) {
  if (data.length < 2) return <span style={{ color: 'var(--dv-text-disabled)' }}>--</span>;

  const min = Math.min(...data);
  const max = Math.max(...data);
  const range = max - min || 1;
  const pad = 2;

  const points = data.map((v, i) => {
    const x = pad + (i / (data.length - 1)) * (width - pad * 2);
    const y = pad + (1 - (v - min) / range) * (height - pad * 2);
    return { x, y };
  });

  const linePoints = points.map(p => `${p.x},${p.y}`).join(' ');

  // Gradient fill path (line + close at bottom)
  const areaPath = showGradient
    ? `M ${points[0].x},${points[0].y} ${points.map(p => `L ${p.x},${p.y}`).join(' ')} L ${points[points.length - 1].x},${height - pad} L ${points[0].x},${height - pad} Z`
    : '';

  const last = data[data.length - 1];
  const prev = data[data.length - 2];
  const dotColor = last > prev ? '#ef4444' : last < prev ? '#10b981' : color;
  const lastPt = points[points.length - 1];
  const gradId = `spark-grad-${Math.random().toString(36).slice(2, 8)}`;

  return (
    <svg width={width} height={height} className="inline-block align-middle">
      {showGradient && (
        <>
          <defs>
            <linearGradient id={gradId} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={color} stopOpacity={0.3} />
              <stop offset="100%" stopColor={color} stopOpacity={0.02} />
            </linearGradient>
          </defs>
          <path d={areaPath} fill={`url(#${gradId})`} />
        </>
      )}
      <polyline
        points={linePoints}
        fill="none"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity={0.8}
      />
      {showDot && (
        <>
          <circle cx={lastPt.x} cy={lastPt.y} r={3.5} fill={dotColor} opacity={0.2} />
          <circle cx={lastPt.x} cy={lastPt.y} r={2} fill={dotColor} />
        </>
      )}
    </svg>
  );
}
